<template>
  <section
      aria-describedby="mobile-access-notice-description"
      aria-labelledby="mobile-access-notice-title"
      aria-modal="true"
      class="mobile-access-notice"
      role="alertdialog"
      @keydown.esc.stop.prevent
      @keydown.tab.prevent
  >
    <div aria-hidden="true" class="mobile-access-notice__backdrop"></div>
    <div class="mobile-access-notice__panel">
      <div aria-hidden="true" class="mobile-access-notice__icon">
        <i class="el-icon-monitor"></i>
      </div>
      <span class="mobile-access-notice__eyebrow">清宸云翼管理后台</span>
      <h1 id="mobile-access-notice-title">请使用电脑访问管理后台</h1>
      <p id="mobile-access-notice-description">
        检测到您正通过手机访问。管理后台包含表格、审批、配置和数据维护等高密度操作，手机端尚未提供完整适配。
      </p>
      <div class="mobile-access-notice__recommendation">
        <i aria-hidden="true" class="el-icon-info"></i>
        <span>建议您在电脑浏览器中重新打开当前后台地址，以获得完整、稳定的操作体验。</span>
      </div>
      <el-button
          ref="acknowledgeButton"
          class="mobile-access-notice__acknowledge"
          native-type="button"
          type="primary"
          @click="acknowledge"
      >
        我已知晓，继续使用
      </el-button>
      <p class="mobile-access-notice__session-tip">此提醒不会记住您的选择；重新打开后台时会再次提示。</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileAccessNotice',
  mounted() {
    // 强提醒出现后将焦点交给唯一确认动作，避免手机辅助功能仍停留在被遮罩内容中。
    this.$nextTick(() => {
      const component = this.$refs.acknowledgeButton
      const button = component && (component.$el || component)
      if (button && typeof button.focus === 'function') {
        button.focus()
      }
    })
  },
  methods: {
    acknowledge() {
      this.$emit('acknowledge')
    },
  },
}
</script>

<style scoped>
.mobile-access-notice {
  position: fixed;
  z-index: 5000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.mobile-access-notice__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(5, 23, 48, 0.74);
  backdrop-filter: blur(4px);
}

.mobile-access-notice__panel {
  position: relative;
  width: min(100%, 460px);
  max-height: calc(100vh - 40px);
  padding: 32px 28px 26px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  color: #172033;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(2, 17, 40, 0.36);
  text-align: center;
}

.mobile-access-notice__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  margin-bottom: 18px;
  border-radius: 18px;
  color: #0057b7;
  background: #e9f2ff;
  font-size: 31px;
}

.mobile-access-notice__eyebrow {
  display: block;
  margin-bottom: 10px;
  color: #0057b7;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.mobile-access-notice h1 {
  margin: 0;
  color: #172033;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.35;
}

.mobile-access-notice > .mobile-access-notice__panel > p {
  margin: 16px 0 0;
  color: #566176;
  font-size: 15px;
  line-height: 1.8;
  text-align: left;
}

.mobile-access-notice__recommendation {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 20px;
  padding: 13px 14px;
  border: 1px solid #cfe3ff;
  border-radius: 12px;
  color: #174b86;
  background: #f3f8ff;
  font-size: 14px;
  line-height: 1.65;
  text-align: left;
}

.mobile-access-notice__recommendation i {
  flex: 0 0 auto;
  margin-top: 3px;
  color: #0057b7;
  font-size: 16px;
}

.mobile-access-notice__acknowledge {
  width: 100%;
  min-height: 46px;
  margin-top: 24px;
  border-color: #0057b7;
  border-radius: 9px;
  background: #0057b7;
  font-size: 15px;
  font-weight: 700;
}

.mobile-access-notice__acknowledge:hover,
.mobile-access-notice__acknowledge:focus {
  border-color: #004a9c;
  background: #004a9c;
  box-shadow: 0 0 0 3px rgba(0, 87, 183, 0.2);
  outline: none;
}

.mobile-access-notice .mobile-access-notice__session-tip {
  margin-top: 13px;
  color: #7b8798;
  font-size: 12px;
  line-height: 1.55;
  text-align: center;
}

@media (max-height: 620px) {
  .mobile-access-notice {
    align-items: flex-start;
  }

  .mobile-access-notice__panel {
    margin: auto 0;
    padding-top: 24px;
  }

  .mobile-access-notice__icon {
    width: 52px;
    height: 52px;
    margin-bottom: 12px;
    font-size: 26px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-access-notice,
  .mobile-access-notice * {
    scroll-behavior: auto;
    transition: none !important;
  }
}
</style>
